import React from "react";
import { useSelector } from "react-redux";
import WizardCategoryItem from "./WizardCategoryItem";
import WizardsInCategory from "./WizardsInCategory";
import { Stack } from "@atlaskit/primitives";
import { listStyles } from "./utils/wizardstyles";
import { wizardCategories } from "./tutorials/wizardRegistry";

const WizardMainFrame = () => {
  const currentCategory = useSelector((state) => state.wizard.currentCategory);

  return (
    <>    
      {currentCategory === "" && (
        <Stack as="ul" xcss={listStyles}>
          {wizardCategories.map((category, i) => (
            <WizardCategoryItem key={i} category={category} />
          ))}
          <p></p>
          <p>Need more wizards, feel free to contact us via the <a href="https://rixter.atlassian.net/servicedesk/customer/portal/2/group/8/create/10" target="_blank">Portal</a></p>
        </Stack>
      )}
      {currentCategory !== "" && <WizardsInCategory />}
    </>
  );
};
export default WizardMainFrame;
